import classNames from 'classnames'
import React, { PropsWithChildren, useEffect, useState } from 'react'
import { LinkDetailType } from 'service/list'
import { ReactComponent as ImageIcon } from 'svg/fi_image.svg'
import { ReactComponent as CheckIcon } from 'svg/fi_check.svg'
import { FormValues } from 'utils/type'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form'

import { FileUploader } from './FileUploader'
import { CreateVideoType } from 'constant/videoTypes'

interface ProductImageSelectorProps {
  selectedLink: LinkDetailType
  index: number
  setValue: UseFormSetValue<FormValues>
  watch: UseFormWatch<FormValues>
  createVideoType: CreateVideoType
}
export const ProductImageSelector = ({
  selectedLink,
  index,
  setValue,
  watch,
  createVideoType,
}: PropsWithChildren<ProductImageSelectorProps>) => {
  const MAX_DURATION = 60
  const videoDuration = watch(`products.${index}.selectedVideoTotalDuration`)

  const [selectedImgs, setSelectedImgs] = useState<
    { order: number; imgUrl: string }[]
  >([])
  const [isAllImgSelect, setIsAllImgSelect] = useState<boolean>(false)

  const updateImageArr = (imgUrl: string) => {
    const found = selectedImgs.find((img) => img.imgUrl === imgUrl)

    if (found) {
      // 선택 해제
      const filtered = selectedImgs
        .filter((img) => img.imgUrl !== imgUrl)
        .map((img, idx) => ({ ...img, order: idx + 1 }))

      setSelectedImgs(filtered)
      setValue(
        `products.${index}.selectedThumbnails`,
        filtered.map((i) => i.imgUrl)
      )
    } else {
      const updated = [
        ...selectedImgs,
        { order: selectedImgs.length + 1, imgUrl },
      ]
      setSelectedImgs(updated)
      setValue(
        `products.${index}.selectedThumbnails`,
        updated.map((i) => i.imgUrl)
      )
    }
  }

  const handleAllImgSelect = () => {
    const imgs = selectedLink?.video?.thumbnail_images ?? []
    const bool = !isAllImgSelect
    setIsAllImgSelect(bool)

    if (bool) {
      const selected = imgs.map((imgUrl, i) => ({
        imgUrl,
        order: i + 1,
      }))
      setSelectedImgs(selected)
      setValue(
        `products.${index}.selectedThumbnails`,
        selected.map((i) => i.imgUrl)
      )
    } else {
      setSelectedImgs([])
      setValue(`products.${index}.selectedThumbnails`, [])
    }
  }

  useEffect(() => {
    const imgs = selectedLink?.video?.thumbnail_images
    if (imgs) {
      setSelectedImgs(
        imgs.map((el, index) => {
          return { order: index + 1, imgUrl: el }
        })
      )
      setValue(`products.${index}.selectedThumbnails`, [...imgs])

      setIsAllImgSelect(true)
    }
  }, [selectedLink])

  return (
    <div
      className={classNames('flex flex-col w-full mt-6', {
        ' opacity-30': videoDuration > MAX_DURATION,
      })}
    >
      <p className="w-full font-bold flex gap-2 items-center justify-between mb-1">
        <div className="flex gap-2 items-center">
          <ImageIcon />
          상품 이미지 선택
        </div>
      </p>

      <div className="bg-[#F6F8FB] w-rounded-[10px] flex flex-col gap-4 p-4">
        <div className="flex justify-between items-center">
          <p className="font-bold text-[14px]">상품 대표 이미지</p>
          <div
            className=" flex items-center gap-1 font-normal  "
            onClick={handleAllImgSelect}
          >
            <div
              className={classNames(
                'w-[22px] h-[22px] rounded-full border-[1px] flex items-center justify-center',
                {
                  'bg-href': isAllImgSelect,
                  'bg-black opacity-70': !isAllImgSelect,
                }
              )}
            >
              {isAllImgSelect && <CheckIcon className="w-[12px] h-[8px]" />}
            </div>
            전체 선택
          </div>
        </div>
        <div className="bg-[#F6F8FB] w-full rounded-[10px] grid  md:grid-cols-10 grid-cols-5  gap-x-[7px]">
          {selectedLink?.video?.thumbnail_images.map((imgUrl, el_index) => {
            const selected = selectedImgs.find((img) => img.imgUrl === imgUrl)
            const order = selected?.order ?? 0

            return (
              <>
                <div
                  className={classNames(
                    'w-[64px] relative flex items-center  bg-white rounded-[2px]',
                    {
                      'h-[115px]':
                        createVideoType === CreateVideoType.PRODUCT_SHORT,
                      'h-[64px]':
                        createVideoType === CreateVideoType.PRODUCT_LONG,
                    }
                  )}
                  onClick={() => {
                    updateImageArr(imgUrl)
                  }}
                >
                  {' '}
                  <img src={imgUrl} alt="" />
                  <div className="absolute flex items-center cursor-pointer right-1 bottom-1 z-50 active:scale-95">
                    <div
                      className={classNames(
                        'w-[28px] h-[28px] rounded-full border-2  flex items-center justify-center  border-href ',
                        {
                          'opacity-100 bg-white': order > 0,
                          'bg-[rgba(0,0,0,0.5)] border-white ': order <= 0,
                        }
                      )}
                    >
                      {order > 0 && (
                        <div className="w-[22px] h-[22px] bg-href rounded-full text-white flex items-center justify-center font-bold">
                          {order}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )
          })}
        </div>
      </div>
      <FileUploader
        watch={watch}
        index={index}
        setValue={setValue}
        setSelectedImgs={setSelectedImgs}
        selectedImgs={selectedImgs}
        isAllImgSelect={isAllImgSelect}
        imgCnt={selectedLink?.video?.thumbnail_images?.length}
        createVideoType={createVideoType}
      />
    </div>
  )
}
